(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-javascript"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      initializeImageSwitching();
      initializeVariantSelection();
      initializeQuantityControls();
      initializeReviewSystem();
      initializeStickyImages();
      initializeVariantCollapse();
    }, 100);
  });

  function initializeVariantCollapse() {
    const wrappers = document.querySelectorAll('.variant-options-wrapper');
    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      const options = wrapper.querySelector('.variant-options');
      const toggle = wrapper.querySelector('.variant-toggle');
      const variantCount = parseInt(wrapper.dataset.variantCount) || 0;

      if (!options || !toggle) return;

      // Show toggle only when there are enough variants (more than 6)
      if (variantCount <= 6) {
        toggle.style.display = 'none';
        wrapper.classList.remove('collapsed');
        options.style.maxHeight = '';
        return;
      }

      // Measure one option height (including gap) and expose 1/3 of the next item
      const firstOption = options.querySelector('.variant-option');
      if (!firstOption) return;
      const style = window.getComputedStyle(options);
      const gap = parseFloat(style.rowGap || style.gap || 12) || 12;

      function computeCollapsedHeight() {
        const rect = firstOption.getBoundingClientRect();
        const optionHeight = Math.max(0, Math.round(rect.height));
        // Show one full row and expose roughly 1/3 of the next item as a hint
        const oneRow = Math.round(optionHeight);
        const expose = Math.max(0, Math.round(optionHeight / 3));
        return { collapsedHeight: oneRow + expose, expose };
      }

      const initial = computeCollapsedHeight();
      // store expose amount as a CSS variable so the overlay can use it
      wrapper.style.setProperty('--variant-collapse-expose', initial.expose + 'px');

      // Start collapsed (two rows + 1/3 of next)
      wrapper.classList.add('collapsed');
      options.style.maxHeight = initial.collapsedHeight + 'px';
      toggle.style.display = '';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'View all';

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          // collapse (recompute in case sizes changed)
          const { collapsedHeight, expose } = computeCollapsedHeight();
          wrapper.style.setProperty('--variant-collapse-expose', expose + 'px');
          options.style.maxHeight = collapsedHeight + 'px';
          wrapper.classList.add('collapsed');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.textContent = 'View all';
        } else {
          // expand to full height
          options.style.maxHeight = options.scrollHeight + 'px';
          wrapper.classList.remove('collapsed');
          toggle.setAttribute('aria-expanded', 'true');
          toggle.textContent = 'Show less';
        }
      });

      // Ensure collapsed state recalculates on resize
      window.addEventListener('resize', () => {
        const { collapsedHeight, expose } = computeCollapsedHeight();
        wrapper.style.setProperty('--variant-collapse-expose', expose + 'px');
        if (toggle.getAttribute('aria-expanded') === 'false') {
          options.style.maxHeight = collapsedHeight + 'px';
        }
      });
    });
  }

  function initializeQuantityControls() {
    const qtyInput =
      document.querySelector('.qty-input') ||
      document.getElementById('quantity-input') ||
      document.querySelector('input[name="quantity"]');
    const minusBtn = document.querySelector('.qty-btn.minus') || document.querySelector('button.minus');
    const plusBtn = document.querySelector('.qty-btn.plus') || document.querySelector('button.plus');
    const addToCartBtn = document.querySelector('.add-to-cart-btn');

    if (!qtyInput) return;

    const minValue = parseInt(qtyInput.getAttribute('min')) || 1;
    const maxValue = parseInt(qtyInput.getAttribute('max')) || 999;

    function updateStates() {
      const currentValue = parseInt(qtyInput.value) || minValue;

      if (minusBtn) {
        const shouldDisable = currentValue <= minValue;
        minusBtn.disabled = shouldDisable;
        minusBtn.style.opacity = shouldDisable ? '0.5' : '1';
        minusBtn.style.cursor = shouldDisable ? 'not-allowed' : 'pointer';
      }

      if (plusBtn) {
        const shouldDisable = currentValue >= maxValue;
        plusBtn.disabled = shouldDisable;
        plusBtn.style.opacity = shouldDisable ? '0.5' : '1';
        plusBtn.style.cursor = shouldDisable ? 'not-allowed' : 'pointer';
      }

      if (addToCartBtn && !addToCartBtn.disabled) {
        addToCartBtn.textContent = currentValue > 1 ? `Add ${currentValue} to cart` : 'Add to cart';
      }
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const currentValue = parseInt(qtyInput.value) || minValue;
        if (currentValue > minValue) {
          qtyInput.value = currentValue - 1;
          updateStates();
          this.style.transform = 'scale(0.95)';
          setTimeout(() => (this.style.transform = 'scale(1)'), 100);
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const currentValue = parseInt(qtyInput.value) || minValue;
        if (currentValue < maxValue) {
          qtyInput.value = currentValue + 1;
          updateStates();
          this.style.transform = 'scale(0.95)';
          setTimeout(() => (this.style.transform = 'scale(1)'), 100);
        }
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', updateStates);
    }

    updateStates();
  }

  function initializeImageSwitching() {
    const thumbnails = document.querySelectorAll('.thumbnail-item');
    const mainImage = document.getElementById('main-product-image');

    if (thumbnails.length > 0) {
      thumbnails[0].classList.add('active');
    }

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        thumbnails.forEach((t) => t.classList.remove('active'));
        this.classList.add('active');

        const newImageUrl = this.dataset.imageUrl;
        if (mainImage && newImageUrl) {
          mainImage.src = newImageUrl;
        }
      });
    });
  }

  function initializeVariantSelection() {
    const variantOptions = document.querySelectorAll('.variant-option');
    const selectedVariant = document.querySelector('.selected-variant');
    const mainImage = document.getElementById('main-product-image');
    const hiddenInput = document.querySelector('input[name="id"]');
    const stockStatus = document.querySelector('.stock-status');
    const addToCartBtn = document.querySelector('.add-to-cart-btn');

    function findPriceElement(root) {
      const selectors = [
        '.price-current',
        '.product-price',
        '.price-regular',
        '.price-sale',
        '.price-compare',
        '.price-per-item--current',
        '.price-item--last',
        '.price',
      ];
      for (const sel of selectors) {
        const el = (root || document).querySelector(sel);
        if (el) return el;
      }
      return null;
    }

    variantOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        if (!this.dataset.available || this.dataset.available === 'false') {
          return;
        }

        variantOptions.forEach((opt) => opt.classList.remove('active'));
        this.classList.add('active');

        const variantId = this.dataset.variantId;
        const variantTitle = this.dataset.variantTitle;
        const variantPrice = this.dataset.variantPrice;
        const variantImage = this.dataset.variantImage;

        if (selectedVariant) selectedVariant.textContent = variantTitle;
        if (mainImage && variantImage) mainImage.src = variantImage;
        if (hiddenInput) hiddenInput.value = variantId;

        const priceElement = findPriceElement(option.closest('product-info') || document.querySelector('product-info'));
        if (priceElement) priceElement.textContent = variantPrice;

        updateStockStatus(this.dataset.available, variantTitle);
      });
    });

    // Dropdown / variant-selects handling: switch media using the mapping embedded in the DOM
    const variantSelectsEl = document.querySelector('variant-selects');
    if (variantSelectsEl) {
      const mappingScript =
        variantSelectsEl.querySelector('script[data-variant-mapping]') ||
        document.querySelector('script[data-variant-mapping]');
      let variantMapping = {};
      try {
        variantMapping = JSON.parse(mappingScript ? mappingScript.textContent : '{}');
      } catch (e) {
        variantMapping = {};
      }

      // If mapping empty or incomplete, build mapping from full variants JSON and select option value ids
      if (!Object.keys(variantMapping).length) {
        const variantsScript = variantSelectsEl.querySelector('script[data-variants]');
        try {
          const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
          const selectsOrder = Array.from(variantSelectsEl.querySelectorAll('select'));

          variants.forEach((variant) => {
            const keyParts = [];
            for (let i = 0; i < selectsOrder.length; i++) {
              const selectEl = selectsOrder[i];
              // find the option element whose value or text matches variant.options[i]
              const match = Array.from(selectEl.options).find((opt) => {
                return opt.value === variant.options[i] || opt.text === variant.options[i];
              });
              keyParts.push(match?.dataset?.optionValueId || match?.value || '');
            }
            const key = keyParts.join('|');
            variantMapping[key] = {
              id: variant.id,
              title: variant.title,
              featured_media_id: variant.featured_media ? variant.featured_media.id : null,
              image: variant.featured_image ? variant.featured_image.src : null,
            };
          });
        } catch (e) {
          // ignore build errors
        }
      }

      // Use delegated listener so it continues to work after product-info swaps DOM
      document.addEventListener('change', function (event) {
        const target = event.target;
        const selectsParent = target.closest('variant-selects');
        if (!selectsParent) return;

        // helper to build or retrieve mapping cached on the element
        function getMapping(el) {
          if (el._variantMapping) return el._variantMapping;
          let map = {};
          const mappingScript =
            el.querySelector('script[data-variant-mapping]') || document.querySelector('script[data-variant-mapping]');
          try {
            map = JSON.parse(mappingScript ? mappingScript.textContent : '{}');
          } catch (e) {
            map = {};
          }

          if (!Object.keys(map).length) {
            const variantsScript = el.querySelector('script[data-variants]');
            try {
              const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
              const selectsOrder = Array.from(el.querySelectorAll('select'));
              variants.forEach((variant) => {
                const keyParts = [];
                for (let i = 0; i < selectsOrder.length; i++) {
                  const selectEl = selectsOrder[i];
                  const match = Array.from(selectEl.options).find((opt) => {
                    return opt.value === variant.options[i] || opt.text === variant.options[i];
                  });
                  keyParts.push(match?.dataset?.optionValueId || match?.value || '');
                }
                const key = keyParts.join('|');
                map[key] = {
                  id: variant.id,
                  title: variant.title,
                  price: variant.price || null,
                  featured_media_id: variant.featured_media ? variant.featured_media.id : null,
                  image: variant.featured_image ? variant.featured_image.src : null,
                };
              });
            } catch (e) {
              // ignore
            }
          }

          el._variantMapping = map;
          return map;
        }

        const selects = Array.from(selectsParent.querySelectorAll('select'));
        if (!selects.length) return;
        const mapping = getMapping(selectsParent);
        const selectedKey = selects
          .map((s) => s.selectedOptions[0].dataset.optionValueId || s.selectedOptions[0].value)
          .join('|');
        const data = mapping[selectedKey];
        const productInfoEl =
          selectsParent.closest('product-info') || document.querySelector('product-info[data-section]');
        const sectionId = productInfoEl?.dataset?.section;
        const mediaGallery =
          productInfoEl?.querySelector('media-gallery') ||
          document.querySelector(`product-info[data-section="${sectionId}"] media-gallery`);

        // Update displayed selected-variant text
        const selectedVariantLabel = document.querySelector('.selected-variant');
        if (data && selectedVariantLabel) {
          selectedVariantLabel.textContent = data.title || selects.map((s) => s.selectedOptions[0].text).join(' / ');
        }

        // Update hidden variant id input so add-to-cart works immediately
        if (data && data.id) {
          const idInputs = Array.from(document.querySelectorAll(`input[name="id"]`));
          idInputs.forEach((input) => {
            input.value = data.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        // Update price section with correct price and compare-at for the selected variant
        if (data && data.price != null) {
          const priceSection = (productInfoEl || document).querySelector('.product-price-section');
          if (priceSection) {
            if (data.compare_at_price) {
              priceSection.innerHTML =
                '<span class="price-sale">' + data.price + '</span>' +
                ' <span class="price-compare">' + data.compare_at_price + '</span>';
            } else {
              priceSection.innerHTML = '<span class="price-regular">' + data.price + '</span>';
            }
          }
          // Update Affirm placement with new variant price (raw cents) and refresh
          const affirmEl = (productInfoEl || document).querySelector('.affirm-as-low-as');
          if (affirmEl && data.raw_price != null) {
            affirmEl.setAttribute('data-amount', data.raw_price);
            if (window.affirm && window.affirm.ui && window.affirm.ui.refresh) {
              window.affirm.ui.refresh();
            }
          }
        }

        if (data && mediaGallery) {
          if (data.featured_media_id) {
            try {
              mediaGallery.setActiveMedia(`${sectionId}-${data.featured_media_id}`, true);
            } catch (e) {
              // ignore if method missing
            }
            return;
          }
        }

        // Fallback: if no media id, try to swap main image src
        if (data && data.image) {
          const mainImg =
            document.querySelector('.product__media-item img') || document.getElementById('main-product-image');
          if (mainImg) mainImg.src = data.image;
        }
      });
    }
  }

  function updateStockStatus(available, variantTitle) {
    const stockStatus = document.querySelector('.stock-status');
    const addToCartBtn = document.querySelector('.add-to-cart-btn');

    if (!stockStatus) return;
    // Unconditional add-to-cart: show stock state but always enable the button.
    if (available === 'true') {
      stockStatus.innerHTML = '<span class="in-stock">In stock</span>';
    } else {
      stockStatus.innerHTML = '<span class="out-of-stock">Sold out</span>';
    }

    if (addToCartBtn) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Add to cart';
      addToCartBtn.classList.remove('disabled');
    }
  }

  function initializeReviewSystem() {
    const writeReviewBtn = document.querySelector('.write-review-btn');
    if (writeReviewBtn) {
      writeReviewBtn.addEventListener('click', function (e) {
        e.preventDefault();
        toggleReviewForm();
      });
    }

    const reviewForm = document.querySelector('.review-form');
    if (reviewForm) {
      reviewForm.addEventListener('submit', submitReview);
    }

    const cancelBtn = document.querySelector('.cancel-review-btn');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', function (e) {
        e.preventDefault();
        toggleReviewForm();
      });
    }

    setupReviewStars();
  }

  function toggleReviewForm() {
    const reviewForm = document.getElementById('reviewForm');
    const writeBtn = document.querySelector('.write-review-btn');

    if (!reviewForm || !writeBtn) return;

    const isFormVisible = reviewForm.style.display !== 'none' && reviewForm.style.display !== '';

    if (isFormVisible) {
      reviewForm.style.display = 'none';
      writeBtn.textContent = 'Write a Review';
      writeBtn.classList.remove('active');
    } else {
      reviewForm.style.display = 'block';
      writeBtn.textContent = 'Cancel Review';
      writeBtn.classList.add('active');
      reviewForm.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      setTimeout(function () {
        const firstInput = reviewForm.querySelector('input[type="text"]');
        if (firstInput) firstInput.focus();
      }, 300);
    }
  }

  function setupReviewStars() {
    const starButtons = document.querySelectorAll('.star-btn');
    const ratingValue = document.getElementById('rating-value');

    starButtons.forEach(function (star, index) {
      star.addEventListener('click', function () {
        const rating = parseInt(this.dataset.rating);
        ratingValue.value = rating;

        starButtons.forEach(function (s, i) {
          if (i < rating) {
            s.classList.add('selected');
          } else {
            s.classList.remove('selected');
          }
        });
      });

      star.addEventListener('mouseenter', function () {
        const rating = parseInt(this.dataset.rating);
        starButtons.forEach(function (s, i) {
          if (i < rating) {
            s.classList.add('hover');
          } else {
            s.classList.remove('hover');
          }
        });
      });
    });

    document.getElementById('starInput').addEventListener('mouseleave', function () {
      starButtons.forEach(function (s) {
        s.classList.remove('hover');
      });
    });
  }

  function submitReview(event) {
    event.preventDefault();

    const formData = new FormData(event.target);
    const productId = document.querySelector('[data-product-id]').dataset.productId;

    const reviewData = {
      name: formData.get('name'),
      email: formData.get('email'),
      rating: formData.get('rating'),
      title: formData.get('title'),
      content: formData.get('content'),
      product_id: productId,
    };

    alert('Thank you for your review! It will be published after moderation.');

    event.target.reset();
    document.getElementById('rating-value').value = '0';
    document.querySelectorAll('.star-btn').forEach((s) => s.classList.remove('selected'));
    toggleReviewForm();
  }

  function initializeStickyImages() {
    const imagesSection = document.querySelector('.product-images-section');
    const productInfo = document.querySelector('.product-info-section');

    if (!imagesSection || !productInfo) return;

    imagesSection.style.position = 'sticky';
    imagesSection.style.top = '2rem';
    imagesSection.style.alignSelf = 'start';

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            imagesSection.classList.add('sticky-active');
          } else {
            imagesSection.classList.remove('sticky-active');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50% 0px',
      }
    );

    observer.observe(productInfo);
  }
  } catch(e) { console.error(e); }
})();

})();
